import {i18n, IIndexSignature} from "@selfserve/react-utils";

export const checklistSubTypesTexts: IIndexSignature<string> = {
  'unisphere-announcement': i18n.t('common.unisphere'),
  'unisphere-banner': i18n.t('common.banner'),
};
